import { FilterPanelBaseFilter } from "./BaseFilter";

export interface IRadioGroupOption<K extends string = string> {
    readonly key: K;
    /** Translation key — the view translates. */
    readonly label: string;
    /** Translation key — renders a per-row info icon when present. */
    readonly tooltip?: string;
}

type RadioGroupFilterModelDeps<K extends string> = {
    readonly options: readonly IRadioGroupOption<K>[];
    readonly initialDtoValue: K;
};

export class RadioGroupFilterModel<K extends string = string> extends FilterPanelBaseFilter<
    K,
    readonly IRadioGroupOption<K>[]
> {
    private readonly defaultValue: K;

    constructor({ options, initialDtoValue }: RadioGroupFilterModelDeps<K>) {
        super({ options, initialDtoValue });

        this.defaultValue = initialDtoValue;
    }

    /** An absent value reads as the default option, so one radio is always selected. */
    fromApiValue(value?: K): K {
        return value ?? this.defaultValue;
    }

    /**
     * An absent value means "untouched", which reads as the default — not as a distinct state. Both sides go
     * through `fromApiValue` so an explicitly stored default is clean.
     */
    isFilterDirty(currentValue?: K): boolean {
        return this.fromApiValue(currentValue) !== this.defaultValue;
    }
}
